import { z } from 'zod';

export const walletStatusSchema = z.enum(['active', 'suspended', 'in_review']);
export type WalletStatus = z.infer<typeof walletStatusSchema>;
